module.exports = __webpack_public_path__ + "static/media/Faceless Void.85c7efc3.png";